import React, { FC, useState } from "react"
import { ScrollObserver }      from "../../common/site/ScrollObserver"

interface Props {}

const defaultProps: Props = {}

const MobileAppsAnimation: FC<Props> = ( props ) => {
  
  return (
    
    <ScrollObserver elementId={ "mobile-apps-animation" } options={ {
      onScrollIntersectClassname: "activated",
      rootMargin:                 "0px 0px -15% 0px"
    } }>
      <div className={ "animation-container scale-75 md:scale-100" }>
        <div className={ "triangle-a" } />
        <div className={ "triangle-b" } />
        <div className={ "triangle-c" } />
        <div className={ "mini-triangle-a" } />
        <div className={ "mini-triangle-b" } />
        <div className={ "mini-triangle-c" } />
        <div className={ "mini-triangle-d" } />
        <div className={ "mini-triangle-e" } />
      </div>
    </ScrollObserver>
  )
}

MobileAppsAnimation.defaultProps = defaultProps

export { MobileAppsAnimation }
